import { render, staticRenderFns } from "./DataTableExpanExcel.vue?vue&type=template&id=2552e130&scoped=true"
import script from "./DataTableExpanExcel.vue?vue&type=script&lang=js"
export * from "./DataTableExpanExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552e130",
  null
  
)

export default component.exports